import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { graphql, gql, compose } from 'react-apollo';

// Redux
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
  Tabs,
  Tab
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CancellationPolicies.css';

// Component
import Flexible from './Flexible';
import Moderate from './Moderate';
import Strict from './Strict';
import Loader from '../Loader';

// Locale
import messages from '../../locale/messages';
import history from '../../core/history'

class CancellationPolicy extends React.Component {

  static propTypes = {
    policyType: PropTypes.string.isRequired,
    siteName: PropTypes.string.isRequired,
    formatMessage: PropTypes.any,
  };

  handleSelect = (key) => {
    let policy = key === 1 ? 'Flexible' : (key === 2 ? 'Moderate' : 'Strict')
    history.push('/cancellation-policies/' + policy)
  }

  render() {
    const { policyType, siteName, data } = this.props;
    const { loading, getCancellationPoliciesData } = data || {};
    
    let policy = (policyType != 'Flexible' && policyType != 'Moderate' && policyType != 'Strict') ? 'Flexible' : policyType;
    
    if (loading) {
      return <Loader type="text" />;
    }
    
    // Get policy data and shared data from GraphQL
    const policies = getCancellationPoliciesData?.policies || [];
    const shared = getCancellationPoliciesData?.shared || {};
    
    // Find current policy data
    const currentPolicy = policies.find(p => p.policyType === policy) || {};
    const flexibleData = policies.find(p => p.policyType === 'Flexible') || {};
    const moderateData = policies.find(p => p.policyType === 'Moderate') || {};
    const strictData = policies.find(p => p.policyType === 'Strict') || {};
    
    return (
      <Grid>
        <Row className={s.landingContainer}>
          <Col lg={12} md={12} sm={12}>
            <h1 className={cx(s.commonTitleText, s.spaceBottom1, s.pageTitle, s.fontWeightBold)}>
              <FormattedMessage {...messages.cancellationPolicies} /></h1>
            <p className={s.spaceBottom6}>
              {shared.allowOwner || <FormattedMessage {...messages.allowOwner} />}
            </p>
            <div className={cx(cx(s.cancellationBg, 'cancellationBg', 'tabBarView', 'tabBarViewRTL'))}>
              <Tabs defaultActiveKey={policy === "Flexible" ? 1 : (policy === "Moderate" ? 2 : 3)} id="uncontrolled-tab-example" onSelect={(e) => this.handleSelect(e)} >
                <Tab eventKey={1} title={<FormattedMessage {...messages.flexible} />}>
                  <Flexible siteName={siteName} policyData={flexibleData} sharedData={shared} />
                </Tab>
                <Tab eventKey={2} title={<FormattedMessage {...messages.moderate} />}>
                  <Moderate siteName={siteName} policyData={moderateData} sharedData={shared} />
                </Tab>
                <Tab eventKey={3} title={<FormattedMessage {...messages.strict} />}>
                  <Strict siteName={siteName} policyData={strictData} sharedData={shared} />
                </Tab>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapState = (state) => ({
  siteName: state.siteSettings.data.siteName
});

const mapDispatch = {};

const GET_CANCELLATION_POLICIES_DATA = gql`
  query getCancellationPoliciesData($locale: String) {
    getCancellationPoliciesData(locale: $locale) {
      status
      policies {
        policyType
        contentOne
        contentTwo
        beforeDaysTitle
        beforeDaysContentOne
        beforeDaysContentTwo
        checkInTitle
        checkInContentOne
        checkInContentTwo
        checkOutTitle
        checkOutContentOne
        checkOutContentTwo
      }
      shared {
        allowOwner
        cancellationCheckIn
        cancellationCheckOut
        cancellationDescription
        cancellationDesc1
        cancellationDesc2
        cancellationDesc3
        cancellationTripStart
        cancellationDesc4
        cancellationDesc5
        cancellationDesc6
        cancellationReview
        cancellationDesc7
      }
    }
  }
`;

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
  graphql(GET_CANCELLATION_POLICIES_DATA, {
    options: (props) => ({
      variables: {
        locale: props.locale || null
      },
      fetchPolicy: 'network-only'
    })
  })
)(CancellationPolicy);
